///////////////////////////////////////////////////////////////////////////////
import adminData from './admin'
import clientData from './client'
import Vue from 'vue'
import Vuex from 'vuex'

import { EventBus } from '../bus.js'
import Helper from '@/helper/helper.js'
///////////////////////////////////////////////////////////////////////////////
Vue.use(Vuex)
///////////////////////////////////////////////////////////////////////////////
//
// Очередь запросов счетчиков тикетов
//
// таймер запроса счетчиков тикетов
let ticketCountersTimer = null
// счетчик пушей за время таймаута
let ticketPushesCounter = 0
// запрос счетчиков тикетов у АПИ
let isTicketTimerRequesting = false
const requestTicketCountersFunction = async (commit) => {
	// если мы в процессе запроса
	if (isTicketTimerRequesting) return

	// не требуется лоадер
	commit('needShowLoader', false)
	isTicketTimerRequesting = true

	try {
		// запросим новые данные
		let response = await Vue.http.get(Vue.APIServerUrl + '/ticket/list?additional=getCounters')
		// если ответ корректный
		if (response && response.data && response.data.status === 'ok' && response.data.result)
			commit('setTicketCounters', response.data.result)
	}
	catch (e) {}

	// включаем лоадер обратно
	commit('needShowLoader', true)
	isTicketTimerRequesting = false
}
// функция которая будет рекурсивно повторятся если есть пуши
const requestTicketAgain = (commit) => {
	// обнулим счетчик пушей
	ticketPushesCounter = 0
	// сразу делаем запрос - первый
	requestTicketCountersFunction(commit)
	// заряжаем запрос - второй
	ticketCountersTimer = setTimeout(() => {
		ticketCountersTimer = null
		// если счетчик пушей так и остался нулевым - ничего не делаем
		// это будет окончание цикла
		if (!ticketPushesCounter) return

		// счетчик пушей не нулевой - то есть были еще пуши
		// начинаем все сначала - следующая итерация цикла
		requestTicketAgain(commit)
	}, 3000)
}

//
// Очередь запросов количества заявок
//
// таймер запроса количества заявок
let requestCountersTimer = null
// счетчик пушей за время таймаута
let requestPushesCounter = 0
// запрос количества заявок у АПИ
let isRequestTimerRequesting = false
const requestRequestCountersFunction = async (commit) => {
	// если мы в процессе запроса
	if (isRequestTimerRequesting) return

	// не требуется лоадер
	commit('needShowLoader', false)
	isRequestTimerRequesting = true

	try {
		// запросим новые данные
		let response = await Vue.http.get(Vue.APIServerUrl + '/request/list?additional=getCounters')
		// если ответ корректный
		if (response && response.data && response.data.status === 'ok' && response.data.result)
			commit('setRequestCounter', response.data.result)
	}
	catch (e) {}

	// включаем лоадер обратно
	commit('needShowLoader', true)
	isRequestTimerRequesting = false
}
// функция которая будет рекурсивно повторятся если есть пуши
const requestRequestAgain = (commit) => {
	// обнулим счетчик пушей
	requestPushesCounter = 0
	// сразу делаем запрос - первый
	requestRequestCountersFunction(commit)
	// заряжаем запрос - второй
	requestCountersTimer = setTimeout(() => {
		requestCountersTimer = null
		// если счетчик пушей так и остался нулевым - ничего не делаем
		// это будет окончание цикла
		if (!requestPushesCounter) return

		// счетчик пушей не нулевой - то есть были еще пуши
		// начинаем все сначала - следующая итерация цикла
		requestRequestAgain(commit)
	}, 3000)
}
///////////////////////////////////////////////////////////////////////////////
export default new Vuex.Store({
	//=========================================================================
	// основной state
	//=========================================================================
	state: {
		// режим дебага
		isDebug: false,

		// блокировано ли приложение
		applicationBlocked: false,

		longRequest: false,
		ajaxRequestsCounter: 0,
		showLongLoader: true,

		// идентификатор приложения
		currentAppId: 'none',

		// текущий язык
		lang: 'en',

		// заголовок страницы
		pageTitle: 'menu/cp',

		// таблица списка грузится
		isListTableLoading: false,

		// инициатор операции
		ItIsMe: false,

		// признак изменений в форме
		changedForm: false,
		isInitFormsValue: 0,

		// счетчик активных загрузок файлов
		uploadFileCounter: 0,

		// версия АПИ
		apiVersion: '',

		// данные по пользователю
		is_auth: false,

		user_id: false,
		user_type: false,
		user_login: false,
		user_avatar: false,
		user_session: false,
		user_role: false,

		user_balance: {
			real: '',
			bonus: '',
			partner: ''
		},

		user_account: false,
		user_forecast: false,

		userServerOptions: {
		},

		user_need: null,

		// конфигурации
		adminConfig: adminData,
		clientConfig: clientData,

		// последние записи списков, с которыми работал пользователь
		lastWorkedRowID: {},

		// последняя страница, с которой работал пользователь
		lastWorkedPage: {},

		// последняя позиция окна
		lastWindowY: {},

		// ширина и высота окна - определяется в функции getWindowWidth плагина "forms"
		// которая в свою очередь вешается на событие "resize" в компоненте workBoard
		windowWidth: 0,
		windowHeight: 0,

		// URL для возвращения
		returnURL: false,

		// воркер Push-системы
		workerPush: false,

		// значение отдельного фильтра в компоненте List
		crudFilter: false,

		// значение фильтра по модели в компоненте List
		modelFilter: false,

		// значение для формы создания заметки
		// из меню операций компонента List
		createNoteData: false,

		// значение для формы активации бонуса сотрудником
		// из меню операций компонента List
		bonusActivateData: false,

		// команда перехода в панель VDS (/vds/view/id - например сразу во вкладку смены тарифа)
		vdsCommand: false,

		// сумма для формы пополнения баланса
		operationSumNew: 10000,

		// данные для тикет системы
		ticketData: {
			// список отделов - для верхних вкладок
			departments: [],
			// выбранная верхняя вкладка
			currentDepartmentId: false,
			// текущие счетчики
			counters: {},
			countersQueue: null,
			ticketViewId: false,
			ticketUpdateId: false,
			// список ID тикетов для которых нужно включить вкладку
			needUpperTab: {}
		},

		// данные для групп VDS
		vdsGroup: {
			// список групп - для верхних вкладок
			groups: [],
			// первая верхняя вкладка
			firstGroupId: null,
			// текущая верхняя вкладка
			currentGroupId: null
		},
		filteredGroupId: null,

		// счетчик активных заявок
		requestCounter: false,
		requestCounterQueue: null,

		// глобальный фильтр
		accountGlobalFilter: false,

		// код ошибки
		errorHttpCode: 0,

		// внутренний кеш QA - если срефрешить приложение, он обнулится
		qaCache: {
			time: null,
			popList: null,
			newList: null,
			tagList: null
		},

		// текущая страница пагинации для компонента Table
		tableCurrentPage: 1,

		// текущий домен, с которым работают
		domainRecordId: null,

		// создение тикета из просмотре тикета по email
		createTicketEmail: null,

		// название пресета для выделения менюшек - левого и верхних табов
		menuSelectingPreset: '',

		// кеш форм
		lastFormCache: {},

		// кеш групп шаблонов
		isLastTemplateGroupCacheLoaded: false,
		lastTemplateGroupCache: [{
			'id': 99999,
			'name': 'main/list_all',
			'active': true
		}],

		// веременное хранение данных (любых)
		temporaryData: null,

		//---------------------------------------------------------------------
		// запрос данных клиента
		//---------------------------------------------------------------------
		getClientData(state) {
			// только для аутентифицированного пользователя
			if (!state.is_auth) return

			// не требуется лоадер
			state.showLongLoader = false

			// запросим данные
			Vue.http.get(Vue.APIServerUrl).then(
				// успешный ответ
				response => {
					// включаем лоадер обратно
					state.showLongLoader = true

					// если ответ корректный
					if (response.data && response.data.status === 'ok')
					{
						if (response.data.balance &&
							response.data.balance.real && 'value' in response.data.balance.real &&
							response.data.balance.bonus && 'value' in response.data.balance.bonus &&
							response.data.balance.partner && 'value' in response.data.balance.partner)
						{
							state.user_balance['real'] = response.data.balance.real.value
							state.user_balance['bonus'] = response.data.balance.bonus.value
							state.user_balance['partner'] = response.data.balance.partner.value
						}

						if (response.data.account && 'value' in response.data.account && response.data.account['value'])
						{
							state.user_account = response.data.account['value']
						}

						if (response.data.forecast && 'value' in response.data.forecast && response.data.forecast['value'])
						{
							state.user_forecast = response.data.forecast['value']
						}

						if (response.data.title)
						{
							state.pageTitle = response.data.title
						}
					}
				},
				// неудачный ответ
				() => {
					// включаем лоадер обратно
					state.showLongLoader = true
				}
			)
		},

		//---------------------------------------------------------------------
		// запрос опций пользователя, сохраненных на АПИ сервере
		//---------------------------------------------------------------------
		getUserOptionsOnServer(state) {
			// только для аутентифицированного пользователя
			if (!state.is_auth) return

			// запросим данные
			Vue.http.get(Vue.APIServerUrl + '/option/get').then(
				// успешный ответ
				response => {
					// если ответ корректный
					if (response.data &&
						response.data.status === 'ok' &&
						response.data.option && Array.isArray(response.data.option) && response.data.option.length)
					{
						// конвертируем данные
						response.data.option.forEach(item => {
							if (typeof item === 'object')
							{
								for (let _prop in item) if (item.hasOwnProperty(_prop))
								{
									state.userServerOptions[_prop] = item[_prop]
								}
							}
						})
						// так как данные изменились асинхронно - сообщаем всем через общую шину событий
						EventBus.$emit('w5-user-options-on-server')
						EventBus.$emit('w5-user-options-on-server-get')
					}
				}
			).catch(data => {})
		},

		//---------------------------------------------------------------------
		// запрос опций пользователя, сохраненных на АПИ сервере
		//---------------------------------------------------------------------
		updateUserOptionsOnServer(state, data) {
			// только для аутентифицированного пользователя
			if (!state.is_auth) return
			// проверка входных данных
			if (!data || !data.key || !('value' in data)) return

			// данные
			let { key, value } = data

			// сохраняем в хранилище
			state.userServerOptions[key] = value

			// так как данные изменились асинхронно - сообщаем всем через общую шину событий
			EventBus.$emit('w5-user-options-on-server')
		},

		//---------------------------------------------------------------------
		// установка опции пользователя на АПИ сервере
		//---------------------------------------------------------------------
		setUserOptionOnServer(state, option, value) {
			// только для аутентифицированного пользователя
			if (!state.is_auth) return

			// параметры
			let _post = { 'value': value }
			// запрос
			Vue.http.post(Vue.APIServerUrl + '/option/set/' + option, Helper.toFormData(_post)).then(
				// успешный ответ
				response => {
					// если ответ корректный
					if (response.data && response.data.status === 'ok')
					{
						// меняем данные
						state.userServerOptions[option] = value
						// так как данные изменились асинхронно - сообщаем всем через общую шину событий
						EventBus.$emit('w5-user-options-on-server')
					}
				}
			)
		},

		//---------------------------------------------------------------------
		// удаление опций пользователя на АПИ сервере
		//---------------------------------------------------------------------
		clearUserOptionsOnServer(state) {
			// только для аутентифицированного пользователя
			if (!state.is_auth) return

			// отправляем GET-запрос на сброс всех опций на сервере
			Vue.http.get(Vue.APIServerUrl + '/option/flush')

			// обнуляем кеш
			state.userServerOptions = {}
		},

		//---------------------------------------------------------------------
		// запрос списка отделов тикетницы - только для сотрудника
		//---------------------------------------------------------------------
		getTicketDepartments(state, tabs) {
			// только для сотрудника
			if (state.user_type !== 'admin') return

			// если данные уже есть
			if (state.ticketData &&
				state.ticketData.departments &&
				Array.isArray(state.ticketData.departments) &&
				state.ticketData.departments.length)
			{
				// сообщаем всем что список обновлен (через общую шину событий приложения)
				EventBus.$emit('w5-ticket-departments')
				// на этом все
				return
			}

			// не требуется лоадер
			state.showLongLoader = false

			// данных еще нет
			Vue.http.get(Vue.APIServerUrl + '/ticket/list?search=department').then(
				// успешный ответ
				response => {
					// включаем лоадер обратно
					state.showLongLoader = true

					// если ответ корректный
					if (response.data && response.data.status === 'ok' && response.data.result &&
						Array.isArray(response.data.result) && response.data.result.length)
					{
						// делаем полную копию полученного массива
						state.ticketData.departments = []
						response.data.result.forEach(item => {
							// добавляем в Vuex
							state.ticketData.departments.push(item)
						})

						// теперь у нас есть массив отделов - формируем вкладки
						let _firstId = false
						adminData.leftMenu.ticket.tabs = {}
						// бежим по всем полученным отделам
						state.ticketData.departments.forEach(item => {
							// добавляем в верхние вкладки только если есть доступ
							if (item && 'access' in item && 'id' in item && item['access'] === true && item['id'])
							{
								// запомним первую вкладку
								if (!_firstId) _firstId = item['id']
								// добавим вкладку: свойство - это URL, а значение свойства - это надпись на вкладке
								adminData.leftMenu.ticket.tabs['ticket/department/' + item['id']] = item['name']
							}
						})
						// в конце добавим вкладку "Все"
						adminData.leftMenu.ticket.tabs['ticket'] = 'main/list_all'

						// если нашли первый доступный отдел - ставим его в ссылке левого меню
						if (_firstId) adminData.leftMenu.ticket.link = '/ticket/department/' + _firstId

						// сообщаем всем что список обновлен (через общую шину событий приложения)
						EventBus.$emit('w5-ticket-departments')
					}
				},
				// неудачный ответ
				() => {
					// включаем лоадер обратно
					state.showLongLoader = true
				}
			)
		},

		//---------------------------------------------------------------------
		// запрос статуса просматриваемого тикета по его ID
		//---------------------------------------------------------------------
		getTicketState(state, ticketId) {
			// если не задан тикет
			if (!ticketId) return
			// статус доступен только сотрудникам
			if (state.user_type !== 'admin') return

			// не требуется лоадер
			state.showLongLoader = false

			// запросим новые данные
			Vue.http.get(Vue.APIServerUrl + '/ticket/view/' + ticketId + '?additional=getState').then(
				// успешный ответ
				response => {
					// включаем лоадер обратно
					state.showLongLoader = true

					// если ответ корректный
					if (response.data && response.data.status === 'ok')
					{
						// готовим списки
						let _view = ''
						let _post = ''

						// смотрим - есть ли те кто просматривает этот же тикет
						if (response.data.view && typeof response.data.view === 'object' && Object.keys(response.data.view).length)
						{
							// посмтроим список смотрящих
							for (let i in response.data.view) if (response.data.view.hasOwnProperty(i))
							{
								// пользователь
								let _user = response.data.view[i]
								// себя пропускаем
								if (String(_user['user_id']) === String(state.user_id)) continue

								// остальных считаем
								if (_view === '') _view = Helper.localeFtc((_user['user_type'] === 'admin' ? 'admin/admin' : 'main/client')).toLowerCase() + ' <b>' + _user['user_name'] + '</b>'
								else _view += '<br>' + Helper.localeFtc((_user['user_type'] === 'admin' ? 'admin/admin' : 'main/client')).toLowerCase() + ' <b>' + _user['user_name'] + '</b>'
							}
						}

						// смотрим - есть ли те кто пишет в этот же тикет
						if (response.data.post && typeof response.data.post === 'object' && Object.keys(response.data.post).length)
						{
							// посмтроим список пишущих
							for (let i in response.data.post) if (response.data.post.hasOwnProperty(i))
							{
								// пользователь
								let _user = response.data.post[i]
								// себя пропускаем
								if (String(_user['user_id']) === String(state.user_id)) continue

								// остальных считаем
								if (_post === '') _post = Helper.localeFtc((_user['user_type'] === 'admin' ? 'admin/admin' : 'main/client')).toLowerCase() + ' <b>' + _user['user_name'] + '</b>'
								else _post += '<br>' + Helper.localeFtc((_user['user_type'] === 'admin' ? 'admin/admin' : 'main/client')).toLowerCase() + ' <b>' + _user['user_name'] + '</b>'
							}
						}

						// если есть те кто смотрит
						if (_view !== '')
							// нужно показать нотификатор
							EventBus.$emit('w5-notificator-add-special', {
								'title': 'ticket/who_view',
								'message': _view,
								'class': 'default',
								'type': 'ticket',
								'special': 'view',
								'timeout': 65000
							})
						else
							// нужно скрыть нотификатор
							EventBus.$emit('w5-notificator-del-special', 'view')

						// если есть те кто пишет
						if (_post !== '')
							// нужно показать нотификатор
							EventBus.$emit('w5-notificator-add-special', {
								'title': 'ticket/who_write',
								'message': _post,
								'class': 'default',
								'type': 'ticket',
								'special': 'post',
								'timeout': 65000
							})
						else
							// нужно скрыть нотификатор
							EventBus.$emit('w5-notificator-del-special', 'post')
					}
				},
				// неудачный ответ
				() => {
					// включаем лоадер обратно
					state.showLongLoader = true
				}
			)
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// мутации основного state'a (менять state можно ТОЛЬКО этими мутациями)
	//=========================================================================
	mutations: {
		//---------------------------------------------------------------------
		// идентификатор текущего приложения
		//---------------------------------------------------------------------
		currentAppId(state) {
			state.currentAppId = (new Date()).getTime() + '-' + Helper.getRandomInt(100000, 999999)
		},
		//---------------------------------------------------------------------
		// изменение количества активных ajax-запросов
		//---------------------------------------------------------------------
		operateAjaxRequestsCounter(state, value) {
			state.ajaxRequestsCounter += value
			if (state.ajaxRequestsCounter < 0) state.ajaxRequestsCounter = 0
		},
		//---------------------------------------------------------------------
		// изменение текущего языка
		//---------------------------------------------------------------------
		setLang(state, value) {
			if (state.lang !== value) state.lang = value
		},
		//---------------------------------------------------------------------
		// лодаре долгой загрузки
		//---------------------------------------------------------------------
		hideLongRequestLoader(state, data) {
			state.longRequest = data
		},
		//---------------------------------------------------------------------
		// показывать или нет лоадера
		//---------------------------------------------------------------------
		needShowLoader(state, data) {
			state.showLongLoader = data
		},
		//---------------------------------------------------------------------
		// сброс аутентификации
		//---------------------------------------------------------------------
		dropAuth(state) {
			state.is_auth = false
			state.user_id = false
			state.user_type = false
			state.user_login = false
			state.user_avatar = false
			state.user_session = false
			state.user_role = false

			state.user_balance['real'] = ''
			state.user_balance['bonus'] = ''
			state.user_balance['partner'] = ''

			state.user_account = false
			state.user_forecast = false
			state.user_need = null

			if (window.localStorage)
			{
				Helper.deleteCookie('w5-user-type')
				window.localStorage.removeItem('user_id')
				window.localStorage.removeItem('user_login')
				window.localStorage.removeItem('user_type')
			}
		},
		//---------------------------------------------------------------------
		// установка аутентификации
		//---------------------------------------------------------------------
		setAuth(state, data) {
			// установка данных
			if (data &&
				'user' in data && data['user'] &&
				'_session' in data && data['_session'] &&
				'user_id' in data['user'] && 'user_email' in data['user'] && 'user_avatar_path' in data['user'])
			{
				state.is_auth = true
				state.user_id = data['user']['user_id']
				state.user_login = data['user']['user_email']
				state.user_avatar = data['user']['user_avatar_path']
				state.user_session = data['_session']
				state.user_type = Helper.validateEmail(data['user']['user_email']) ? 'client' : 'admin'
				state.user_role = false

				// если заданы роли пользователя
				if ('role' in data && data['role'])
				{
					state.user_role = data['role']
				}

				// если есть поле "need"
				if ('need' in data && data['need'] && typeof data['need'] === 'object')
				{
					state.user_need = data['need']
				}

				// если явно указан тип пользователя
				if ('user_type' in data['user'] && data['user']['user_type'] && (data['user']['user_type'] === 'admin' || data['user']['user_type'] === 'user'))
					state.user_type = data['user']['user_type'] === 'admin' ? 'admin' : 'client'

				// сохраним в localStorage и в куках
				Helper.setCookie('w5-user-type', state.user_type === 'admin' ? 's' : 'c', { 'expires': 60 * 60 * 24 * 365, 'domain': Vue.CookieDomain, 'path': '/' })
				if (window.localStorage)
				{
					window.localStorage.setItem('user_id', state.user_id)
					window.localStorage.setItem('user_login', state.user_login)
					window.localStorage.setItem('user_type', state.user_type)
				}

				// если это клиент - запросим баланс
				if (state.user_type === 'client') state.getClientData(state)

				// запросим опции пользователя с АПИ сервера
				state.getUserOptionsOnServer(state)
			}
			else
			{
				// данные некорректны
				state.is_auth = false
				state.user_id = false
				state.user_type = false
				state.user_login = false
				state.user_avatar = false
				state.user_session = false
				state.user_role = false

				state.user_balance['real'] = ''
				state.user_balance['bonus'] = ''
				state.user_balance['partner'] = ''

				state.user_account = false
				state.user_forecast = false
				state.user_need = null

				if (window.localStorage)
				{
					Helper.deleteCookie('w5-user-type')
					window.localStorage.removeItem('user_id')
					window.localStorage.removeItem('user_login')
					window.localStorage.removeItem('user_type')
				}
			}
		},
		//---------------------------------------------------------------------
		// установка последней записи таблицы с которой работал пользователь
		//---------------------------------------------------------------------
		setLastRow(state, data) {
			if (!data || !data['crud']) return

			if (data['id'])
			{
				state.lastWorkedRowID[data['crud']] = data['id']
			}
			else
			{
				delete state.lastWorkedRowID[data['crud']]
			}
		},
		//---------------------------------------------------------------------
		// установка номера последней страницы таблицы с которой работал пользователь
		//---------------------------------------------------------------------
		setLastPage(state, data) {
			if (!data || !data['crud']) return

			if (data['page'])
			{
				state.lastWorkedPage[data['crud']] = data['page']
			}
			else
			{
				delete state.lastWorkedPage[data['crud']]
			}
		},
		//---------------------------------------------------------------------
		// установка позиции окна
		//---------------------------------------------------------------------
		setLastWindowY(state, data) {
			if (!data || !data['url']) return

			if (data['y'])
			{
				state.lastWindowY[data['url']] = data['y']
			}
			else
			{
				delete state.lastWindowY[data['url']]
			}
		},
		//---------------------------------------------------------------------
		// установка ширины и высоты окна
		//---------------------------------------------------------------------
		setWindowSize(state, data) {
			state.windowWidth = data.width
			state.windowHeight = data.height
		},
		//---------------------------------------------------------------------
		// установка значения для отдельного фильтра в компоненте List
		//---------------------------------------------------------------------
		setCrudFilter(state, data) {
			if (typeof data === 'object') state.crudFilter = Object.assign({}, data)
			else state.crudFilter = data
		},
		//---------------------------------------------------------------------
		// установка значения для фильтра по модели в компоненте List
		//---------------------------------------------------------------------
		setModelFilter(state, data) {
			if (typeof data === 'object') state.modelFilter = Object.assign({}, data)
			else state.modelFilter = data
		},
		//---------------------------------------------------------------------
		// установка значения для команды перехода в панель управления VDS
		//---------------------------------------------------------------------
		setVdsCommand(state, data) {
			if (typeof data === 'object') state.vdsCommand = Object.assign({}, data)
			else state.vdsCommand = data
		},
		//---------------------------------------------------------------------
		// установка значения для отдельного фильтра в логах
		//---------------------------------------------------------------------
		createNoteData(state, data) {
			if (typeof data === 'object') state.createNoteData = Object.assign({}, data)
			else state.createNoteData = data
		},
		//---------------------------------------------------------------------
		// установка значения для активации бонуса сотрудником
		//---------------------------------------------------------------------
		bonusActivateData(state, data) {
			if (typeof data === 'object') state.bonusActivateData = Object.assign({}, data)
			else state.bonusActivateData = data
		},
		//---------------------------------------------------------------------
		// установка значения URL для возврата
		//---------------------------------------------------------------------
		setReturnURL(state, value) {
			state.returnURL = value
		},
		//---------------------------------------------------------------------
		// установка значения суммы пополнения баланса
		//---------------------------------------------------------------------
		setOperationSumNew(state, value) {
			state.operationSumNew = value
		},
		//---------------------------------------------------------------------
		// старт Push-системы
		//---------------------------------------------------------------------
		pushStart(state) {
			// инициализация Push-системы
			if (!state.workerPush)
			{
				// создадим worker
				state.workerPush = new Worker('/static/js/worker-push.js?_=' + Vue.AppVersion)

				// определим обработчик
				state.workerPush.onmessage = function(e) {
					// если задан ID последнего сообщения - запомним его в localStorage (web wroker не умеет)
					if (e.data && e.data.cmd && e.data.cmd === 'lid' &&
						e.data.id && window.localStorage)
					{
						window.localStorage.setItem('push_last_id', e.data.id)
					}
					// если указано событие - передадим его дальше
					if (e.data && e.data.cmd && e.data.cmd === 'msg' && e.data.msg)
					{
						if (state.isDebug) window.DEBUG.log('Push-message: ' + e.data.msg)
						EventBus.$emit('w5-push', e.data.msg)
					}
					// если пришла команда на остановку
					if (e.data && e.data.cmd && e.data.cmd === 'terminate')
					{
						state.workerPush.terminate()
						if (state.isDebug) window.DEBUG.log('PUSH: terminated')
					}
				}
			}

			// сам старт Push-системы
			if (state.workerPush)
			{
				// получим ID последнего сообщения
				let _lastMsgId = false
				if (window.localStorage) _lastMsgId = window.localStorage.getItem('push_last_id')

				// стартуем
				state.workerPush.postMessage({
					cmd: 'start',
					url: Vue.PushUrl,
					sid: state.user_session,
					lid: _lastMsgId
				})
			}
		},
		//---------------------------------------------------------------------
		// остановка PUSH-системы
		//---------------------------------------------------------------------
		pushStop(state) {
			if (state.workerPush)
			{
				state.workerPush.postMessage({
					cmd: 'stop'
				})
			}
		},
		//---------------------------------------------------------------------
		// запрос данных пользователя
		//---------------------------------------------------------------------
		getUserData(state) {
			state.getClientData(state)
		},
		//---------------------------------------------------------------------
		// запрос списка отделов для тикет-системы
		//---------------------------------------------------------------------
		getTicketDepartments(state, tabs) {
			state.getTicketDepartments(state, tabs)
		},
		//---------------------------------------------------------------------
		// запрос статуса тикета для тикет-системы
		//---------------------------------------------------------------------
		getTicketState(state, ticketId) {
			state.getTicketState(state, ticketId)
		},
		//---------------------------------------------------------------------
		// ID выбранного отдела по тикетам
		//---------------------------------------------------------------------
		setTicketDepartmentId(state, id) {
			state.ticketData.currentDepartmentId = id
		},
		//---------------------------------------------------------------------
		// ID тикета который просматривают
		//---------------------------------------------------------------------
		setTicketViewId(state, id) {
			// установка ID
			state.ticketData.ticketViewId = id
			// если стоит признак того что нужно определить вкладку
			if (state.ticketData.needUpperTab[id] === true)
			{
				// ставим признак-команду: нужно определить вкладку
				state.ticketData.currentDepartmentId = false
				// удалим из признаков верхних вкладок
				delete state.ticketData.needUpperTab[id]
			}
		},
		//---------------------------------------------------------------------
		// ID тикета в котором собираются менять сообщение
		//---------------------------------------------------------------------
		setTicketUpdateId(state, id) {
			state.ticketData.ticketUpdateId = id
		},
		//---------------------------------------------------------------------
		// установка текущего ID группы VDS
		//---------------------------------------------------------------------
		setVdsGroupId(state, Id) {
			let id = parseInt(Id)
			state.vdsGroup.currentGroupId = isNaN(id) || id <= 0 ? null : id
		},
		//---------------------------------------------------------------------
		// установка ID группы VDS - для дальнейшего установления фильтра
		// по группе
		//---------------------------------------------------------------------
		setFilteredGroupId(state, id) {
			state.filteredGroupId = id
		},
		//---------------------------------------------------------------------
		// установка инициатора операции
		//---------------------------------------------------------------------
		ItIsMe(state, value) {
			state.ItIsMe = value
		},
		//---------------------------------------------------------------------
		// включает флаг блокировки приложения
		//---------------------------------------------------------------------
		blockApplication(state) {
			EventBus.$emit('w5-body-scroll-disable')
			state.longRequest = false
			state.applicationBlocked = true
		},
		//---------------------------------------------------------------------
		// включает флаг изменения формы - значение это URL изменяемой формы
		//---------------------------------------------------------------------
		changedForm(state, value) {
			state.changedForm = value
		},
		//---------------------------------------------------------------------
		// флаг установки начальных значений форм
		//---------------------------------------------------------------------
		isInitFormsValue(state, value) {
			if (value === true) state.isInitFormsValue++
			else state.isInitFormsValue--
			if (state.isInitFormsValue < 0) state.isInitFormsValue = 0
		},
		//---------------------------------------------------------------------
		// счетчик загружаемых файлов
		//---------------------------------------------------------------------
		uploadFileCounter(state, value) {
			if (value === '-') state.uploadFileCounter--
			else if (value === '+') state.uploadFileCounter++

			if (state.uploadFileCounter < 0) state.uploadFileCounter = 0
		},
		//---------------------------------------------------------------------
		// изменение опции пользователя по проигрыванию звука при нотификации
		//---------------------------------------------------------------------
		toggleAudioNitificationOption(state) {
			// получим текущее значение
			let _value = Helper.normalizeBooleanValue(state.userServerOptions['play_audio_on_notification'])
			// если значения нет - это true
			if (!('play_audio_on_notification' in state.userServerOptions))
				_value = true
			// установим другое значение
			state.setUserOptionOnServer(state, 'play_audio_on_notification', !_value)
		},
		//---------------------------------------------------------------------
		// изменение опции пользователя по проигрыванию звука при нотификации
		//---------------------------------------------------------------------
		setAudioTrackNitificationOption(state, value) {
			// нормализуем
			let _value = '0' + String(value)
			// установим другое значение
			state.setUserOptionOnServer(state, 'audio_track_on_notification', _value)
		},
		//---------------------------------------------------------------------
		// удаляем все настройки пользователя на АПИ-сервере
		//---------------------------------------------------------------------
		clearUserOptionsOnServer(state) {
			state.clearUserOptionsOnServer(state)
		},
		//---------------------------------------------------------------------
		// обновляем опции пользователя
		//---------------------------------------------------------------------
		updateUserOptionsOnServer(state, data) {
			state.updateUserOptionsOnServer(state, data)
		},
		//---------------------------------------------------------------------
		// обновляем путь к мини-аватару
		//---------------------------------------------------------------------
		setAvatarPath(state, path) {
			state.user_avatar = path
		},
		//---------------------------------------------------------------------
		// грузится таблица списка или нет
		//---------------------------------------------------------------------
		ListTableLoading(state, value) {
			state.isListTableLoading = value
		},
		//---------------------------------------------------------------------
		// глобальный фильтр
		//---------------------------------------------------------------------
		accountGlobalFilter(state, data) {
			if (typeof data === 'object') state.accountGlobalFilter = Object.assign({}, data)
			else state.accountGlobalFilter = data
		},
		//---------------------------------------------------------------------
		// код HTTP-ошибки
		//---------------------------------------------------------------------
		errorHttpCode(state, value) {
			if (value) state.errorHttpCode = value
			else state.errorHttpCode = 0
		},
		//---------------------------------------------------------------------
		// нужно ли включать верхную вкладку для тикета
		//---------------------------------------------------------------------
		needUpperTab(state, value) {
			state.ticketData.needUpperTab[value] = true
		},
		//---------------------------------------------------------------------
		// включен или выключен режим дебага
		//---------------------------------------------------------------------
		debugMode(state, value) {
			state.isDebug = value
		},
		//---------------------------------------------------------------------
		// установка версии АПИ
		//---------------------------------------------------------------------
		setApiVersion(state, data) {
			state.apiVersion = ''

			if (data && data.title) state.pageTitle = data.title

			if (!data || !data.version || !data.yii) return

			state.apiVersion = 'api ' + data.version + ' (' + data.yii + ')'
		},
		//---------------------------------------------------------------------
		// кеш запроса к QA
		//---------------------------------------------------------------------
		setQACache(state, value) {
			// если данных нет или они некорректны
			if (!value || typeof value !== 'object' || !value.popList || !value.newList || !value.tagList)
			{
				state.qaCache = {
					time: null,
					popList: null,
					newList: null,
					tagList: null
				}

				return
			}

			// формируем данные для кеша
			state.qaCache = {
				// кешируем данные на 10 минут
				time: Helper.unixTime() + 600,
				popList: value.popList,
				newList: value.newList,
				tagList: value.tagList
			}
		},
		//---------------------------------------------------------------------
		// текущая страница пагинации для компонента Table
		//---------------------------------------------------------------------
		tableCurrentPage(state, value) {
			state.tableCurrentPage = value
		},
		//---------------------------------------------------------------------
		// текущий домен, с которым работают
		//---------------------------------------------------------------------
		domainRecordId(state, value) {
			state.domainRecordId = value
		},
		//---------------------------------------------------------------------
		// создение тикета из просмотре тикета по email
		//---------------------------------------------------------------------
		createTicketEmail(state, value) {
			state.createTicketEmail = value
		},
		//---------------------------------------------------------------------
		// установка счетчиков тикетницы
		//---------------------------------------------------------------------
		setTicketCounters(state, value) {
			state.ticketData.counters = value
		},
		//---------------------------------------------------------------------
		// установка счетчика заявок
		//---------------------------------------------------------------------
		setRequestCounter(state, value) {
			state.requestCounter = value
		},
		//---------------------------------------------------------------------
		// обновление баланса клиента
		//---------------------------------------------------------------------
		updateUserBalance(state, data) {
			if (data && data.balance && typeof data.balance === 'object')
			{
				// real
				if ('real' in data.balance &&
					typeof data.balance.real === 'object' &&
					'value' in data.balance.real)
				{
					state.user_balance['real'] = data.balance.real.value
				}
				// bonus
				if ('bonus' in data.balance &&
					typeof data.balance.bonus === 'object' &&
					'value' in data.balance.bonus)
				{
					state.user_balance['bonus'] = data.balance.bonus.value
				}
				// partner
				if ('partner' in data.balance &&
					typeof data.balance.partner === 'object' &&
					'value' in data.balance.partner)
				{
					state.user_balance['partner'] = data.balance.partner.value
				}
			}
		},
		//---------------------------------------------------------------------
		// установка пресета выделения меню
		//---------------------------------------------------------------------
		setMenuSelectingPreset(state, value) {
			state.menuSelectingPreset = value
		},
		//---------------------------------------------------------------------
		// кеш форм
		//---------------------------------------------------------------------
		saveFormCache(state, value) {
			if (!state.lastFormCache) state.lastFormCache = {}
			if (!value || !value.formName || !value.data) return

			state.lastFormCache[value.formName] = {
				data: value.data,
				ttl: new Date().getTime() + (value.ttl ? value.ttl : 500)
			}
		},
		clearFormCache(state, value) {
			if (!value || !state.lastFormCache || !state.lastFormCache[value]) return

			delete state.lastFormCache[value]
		},
		//---------------------------------------------------------------------
		// кеш групп шаблонов
		//---------------------------------------------------------------------
		saveTemplateGroupCache(state, value) {
			state.isLastTemplateGroupCacheLoaded = false
			state.lastTemplateGroupCache = [{
				'id': 99999,
				'name': 'main/list_all',
				'active': true
			}]

			// если данных так и нет
			if (!value || value.status !== 'ok' || !value.groups || !value.groups.length) return

			// данные пришли
			state.isLastTemplateGroupCacheLoaded = true
			state.lastTemplateGroupCache = value.groups
		},
		//---------------------------------------------------------------------
		// временные данные
		//---------------------------------------------------------------------
		temporaryData(state, value) {
			state.temporaryData = value
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// действия - асинхронные процедуры
	//=========================================================================
	actions: {
		//---------------------------------------------------------------------
		// запрос групп шаблонов
		//---------------------------------------------------------------------
		async getTemplateGroupCache({ state, commit }) {
			let _dt = false
			for (let i = 0; i < 3; i++)
			{
				try {
					// делаем сам запрос
					await Vue.http.get(Vue.APIServerUrl + '/templategroup/export').then(
						// успешный ответ
						res => {
							_dt = res.data && typeof res.data === 'object' && res.data['status'] === 'ok' ? res.data : false
							commit('saveTemplateGroupCache', _dt)
						}
					)

					// если получили ответ
					if (_dt) return
				}
				catch (err) {}
			}

			// получить не удалось
			commit('saveTemplateGroupCache', false)
		},

		//---------------------------------------------------------------------
		// запрос версии АПИ
		//---------------------------------------------------------------------
		getApiVersion({ state, commit }) {
			// только для авторизованных сотрудников
			if (state.user_type !== 'admin') return

			// делаем сам запрос
			Vue.http.get(Vue.APIServerUrl + '/admin/index').then(
				// успешный ответ
				res => {
					let _dt = res.data && typeof res.data === 'object' && res.data['status'] === 'ok' ? res.data : false
					commit('setApiVersion', _dt)
				}
			)
		},

		//---------------------------------------------------------------------
		// запрос счетчиков по тикетам
		//---------------------------------------------------------------------
		getTicketCounters({ state, commit }, isPush) {
			// только для аутентифицированного пользователя
			if (!state.is_auth) return

			// если это не пуш - просто сразу делаем запрос и все
			if (!isPush)
			{
				requestTicketCountersFunction(commit)
				return
			}

			// если таймер не запущен - это "первый" пуш
			if (!ticketCountersTimer)
			{
				requestTicketAgain(commit)
			}
			// таймер запущен - это уже последующий пуш
			else
			{
				// просто увеличиваем счетчик пушей
				ticketPushesCounter++
			}
		},

		//---------------------------------------------------------------------
		// запрос счетчика по заявкам
		//---------------------------------------------------------------------
		getRequestCounter({ state, commit }, isPush) {
			// только для авторизованных сотрудников
			if (state.user_type !== 'admin') return

			// если это не пуш - просто сразу делаем запрос и все
			if (!isPush)
			{
				requestRequestCountersFunction(commit)
				return
			}

			// если таймер не запущен - это "первый" пуш
			if (!requestCountersTimer)
			{
				requestRequestAgain(commit)
			}
			// таймер запущен - это уже последующий пуш
			else
			{
				// просто увеличиваем счетчик пушей
				requestPushesCounter++
			}
		}

		//---------------------------------------------------------------------
	}
	//=========================================================================
})
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/store/index.js